// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Realtime_wrapper__3ug9L"};